import React from "react";
import PropTypes from "prop-types";
import { Close } from '@sainsburys-tech/icons'

const CloseButton = props => (
  <Close
    className="cb-c-close-button"
    onClick={props.onClick}
  />
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

CloseButton.defaultProps = {
  onClick: () => {}
};

export default CloseButton;
